export default __webpack_public_path__ + "static/media/iss.0b63ff45.png";